import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/equip-title.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-11b89092"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "main"
};
var _hoisted_2 = {
  class: "content"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "main-top"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "eq-pic"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "mian-font"
  }, "新闻动态")], -1);
});

var _hoisted_4 = {
  class: "news"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "news-title"
};
var _hoisted_8 = {
  class: "date"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      style: {
        "position": "relative",
        "cursor": "pointer"
      },
      onClick: function onClick($event) {
        return _ctx.handleClick(item);
      }
    }, [_createElementVNode("img", {
      class: "news-item",
      src: item.cover_pic_file_url
    }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(item.news_title), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.dayjs(item.create_time).format('YYYY-MM-DD HH:mm:ss')), 1)], 8, _hoisted_5);
  }), 128))])])]);
}